/**
 * @param {string} a 
 * @param {string} b 
 */
export function compareGUIDs(a, b) {
    var charsToStrip = /[{}-]/g;
    return a.replace(charsToStrip, "").toLowerCase() === b.replace(charsToStrip, "").toLowerCase();
}